export default "__VITE_ASSET__70nzj6Et__"